import React from 'react';
import CulturalFiesta2023 from 'views/CulturalFiesta2023';

const SchoolProgrampage = () => {
  return <CulturalFiesta2023 />;
};

export default SchoolProgrampage;